import React, { FunctionComponent, useEffect, useMemo, useState } from 'react';
import commonStyle from '../../Screens/common.module.css';
import { useTable, useColumnOrder } from 'react-table';

import { connect, useDispatch } from 'react-redux';
import TableHeader from '../TableHeader/TableHeader';
import CustomToggle from '../CustomToggle';
import {
  googleAnalyticsCTAClick,
  updateUserImport,
  updateUserStatus,
  updateUserStatusMongo,
} from '../../Services/users';

import {
  updateAPIStatus,
  updateOrganizationStatus,
} from '../../Services/organizations';
import ColumnManagerModal from '../Modals/ColumnManagerModal/ColumnManager';
import {
  setClearFilter,
  setContactsSearchString,
  setTasksSearchString,
  setCallsSearchString,
  showSnackbarAction,
  setReenquiredSearchString,
} from '../../Redux/actions';
import { useHistory } from 'react-router';
import { FiEdit3 } from 'react-icons/fi';
import { FcBusinessman } from "react-icons/fc";
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import BookmarksIcon from '@mui/icons-material/Bookmarks';
import Loading from '../Loading/Loading';

import InfiniteScroll from 'react-infinite-scroll-component';
import { useLocation } from 'react-router-dom';

import DistributionModel from '../Modals/DistributionModel/DistributionModel';
import { themeColors } from '../theme';
import { calllogHideColumn, contactHideColumn, localstorageKey, taskHideColumn } from '../../Values/constants';
import AudioPlayer from '../AudioPlayer/AudioPlayer';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import VisibilityOffIcon from '@mui/icons-material/VisibilityOff';
import { pushToGA } from '../../Services/users';
import BoosterLockRedUnlock from "../../Assets/Images/booster-lock-red-unlock.png"
import UnlockBoosterLeadsTooltip from '../Modals/BoosterLeads/UnlockBoosterLeadsTooltip';

type props = {
  tableColumns: any[];
  tableRows: any[] | undefined;
  selectedRows: any[];
  setSelectedRows: (data: any[]) => void;
  tableType:
  | 'Organization'
  | 'Super admin'
  | 'User'
  | 'Task'
  | 'Project'
  | 'CallLogs'
  | 'API'
  | 'API Leads'
  | 'NEWS'
  | 'LeadDistributor'
  | 'DrillDown'
  | 'Reenquired'
  | 'projects'
  | 'DeletedLogs'
  ;
  showColumnModal: boolean;
  hideColumnModal: () => void;
  selectedRowsData?: any[];
  setSelectedRowsData?: (data: any[]) => void;

  organization: any;
  organizationUsers: any[];
  role: any;
  page: any;
  pageSize: number;
  setPage: (data: any) => void;
  setPageSize: (data: any) => void;
  isFinished: boolean;
  lastPage: number;
  totalCount: any;
  setBranch?: (text: boolean) => void;
  setUid?: (data: string) => void;
  user: any;
  setApiModal?: (data: boolean) => void;
  setApiEdit?: (data: boolean) => void;
  setApiData?: (data: any) => void;

  callApi?: (data: boolean, data2: Number | undefined) => Promise<void>;
  theme: any,
  DrillDownpanel?:any
  panel?:any
  organizationData?:any;
  callRecordingModule?: any;
};

const ApiCustomTable: FunctionComponent<props> = ({
  tableColumns,
  tableRows,
  selectedRows,
  setSelectedRows,
  tableType,
  showColumnModal,
  hideColumnModal,
  selectedRowsData,
  setSelectedRowsData,

  organization,
  organizationUsers,
  role,
  setBranch,
  setUid,
  user,
  setApiModal,
  setApiEdit,
  setApiData,
  page,
  pageSize,
  setPage,
  setPageSize,
  callApi,
  isFinished,
  lastPage,
  totalCount,
  theme,
  DrillDownpanel,
  panel,
  organizationData,
  callRecordingModule
}) => {
  const dispatcher = useDispatch();
  const history = useHistory();
  const pageSizeOptions = [10, 25, 50, 100, 200, 500];
  const [checked, setChecked] = useState(false);
  const [showDistributionModal, setShowDistributionModal] = useState(false);
  const [load, setLoad] = useState(false);
  const [distributionData, setDistributionData] = useState();
  const [indexs, setIndex] = useState(0);
  const [pageData, setPageData] = useState<any[]>([]);
  const [showAudioPlayer, setShowAudioPlayer] = useState(false);
  const [callRecordingUrl, setCallRecordingUrl] = useState("");
  const [showUnlockBoosterTooltip, setShowUnlockBoosterTooltip]:any = useState(null);
  // const tableRef = useRef<HTMLTableElement>(null); // Reference to the table

  useEffect(() => {
    if (tableRows) {
      const data = tableRows.slice(pageSize * page, pageSize * page + pageSize);
      setPageData(data);
    }
  }, [page, pageSize, tableRows]);

  const selectAll = (checked: boolean) => {

    const filterSelectedRows = (arr:any) => {
      let newArr = Array.from(new Set(arr.map((item:any) =>  item)));
      return newArr;
    }

    const uniqByProp_map = (prop:any) => (arr:any) =>
    Array.from(
      arr
        .reduce(
          (acc:any, item:any) => (
            item && item[prop] && acc.set(item[prop], item),
            acc
          ),
          new Map()
        )
        .values()
    );
    const uniqueById = uniqByProp_map("contactId");

    if (
      tableType === 'User' ||
      tableType === 'Project' ||
      tableType === 'Organization' ||
      tableType === 'CallLogs' ||
      tableType === 'Task' ||
      tableType === 'projects' ||
      tableType === 'API Leads' ||
      tableType ==="DeletedLogs"
    ) {
      if (checked === true) {
        if (tableRows) {
          let selectRowsIndex: any[] = [...selectedRows];
          let newRowIndex;
          if(tableType === "API Leads"){
            newRowIndex = pageData.map((lead) => lead._id);
          }else{
            if(tableType === "User"){
              newRowIndex = pageData.map((lead) => {
                if(lead.lead_sub_type && (lead.lead_sub_type !== "Masked Booster Leads")){
                  return lead.contactId;
                }
                else if(lead.lead_sub_type && (lead.lead_sub_type === "Masked Booster Leads")){
                  // Do Nothing
                }
                else{
                  return lead.contactId;
                }
              });
            }else{
              newRowIndex = pageData.map((lead) => lead.contactId || lead.project_id);
            }
          } 
          let allSelectedRows = [...newRowIndex, ...selectRowsIndex];
          let filteredRows = filterSelectedRows(allSelectedRows);
          if(tableType === "User" || tableType ==="DeletedLogs"){
            setSelectedRows(filteredRows);
          }else{
            setSelectedRows(allSelectedRows);
          }
        }

        if (tableRows) {
          if (selectedRowsData) {
            let selectRows: any[] = [...selectedRowsData];
            pageData.forEach((item: any) => {
              if(tableType === "User"){
                if(item.lead_sub_type && (item.lead_sub_type !== "Masked Booster Leads")){
                  selectRows.push(item);
                }
                if(item.lead_sub_type && (item.lead_sub_type === "Masked Booster Leads")){
                  // Do Nothing
                }
                else{
                  selectRows.push(item);
                }
              }
              else{
                selectRows.push(item);
              }
            });
            let filteredRowsData = uniqueById(selectRows);
            if(tableType === "User" || tableType ==="DeletedLogs"){
              setSelectedRowsData && setSelectedRowsData(filteredRowsData);
            }else{
              setSelectedRowsData && setSelectedRowsData(selectRows);
            }
          } else {
            let selectRows: any[] = [];
            pageData.forEach((item: any) => {
              if(tableType === "User"){
                if(item.lead_sub_type && (item.lead_sub_type !== "Masked Booster Leads")){
                  selectRows.push(item);
                }
                else if(item.lead_sub_type && (item.lead_sub_type === "Masked Booster Leads")){
                  // Do Nothing
                }
                else{
                  selectRows.push(item);
                }
              }
              else{
                selectRows.push(item);
              }
            });
            let filteredRowsData = uniqueById(selectRows);
            if(tableType === "User" || tableType ==="DeletedLogs"){
              setSelectedRowsData && setSelectedRowsData(filteredRowsData);
            }else{
              setSelectedRowsData && setSelectedRowsData(selectRows);
            }
          }
        }
      } else {
        setSelectedRows([]);
        setSelectedRowsData && setSelectedRowsData([]);
      }
    } else {
      if (checked === true) {
        setSelectedRows(Array.from(Array(pageData.length).keys()));
      } else {
        setSelectedRows([]);
      }
    }
  };

  const columns = useMemo(() => tableColumns, [tableColumns]);
  const data = useMemo(() => pageData, [pageData]);
  const [currentLimit, setCurrentLimit] = useState(20);
  const [active, setActiveUsers] = useState(0);
  let initialState
  let contactHiddenColumn = localStorage.getItem('contactHiddenColumn')
  let calllogHiddenColumn = localStorage.getItem('calllogHiddenColumn')
  let taskHiddenColumn = localStorage.getItem('taskHiddenColumn')

  if(tableType == "User"){
    initialState = { hiddenColumns:contactHiddenColumn === null?contactHideColumn:JSON.parse(contactHiddenColumn)};
  }
  else if(tableType == "CallLogs"){
    initialState = { hiddenColumns:calllogHiddenColumn === null?calllogHideColumn:JSON.parse(calllogHiddenColumn)};
  }
  else if(tableType == "Task"){
    initialState = { hiddenColumns:taskHiddenColumn === null?taskHideColumn:JSON.parse(taskHiddenColumn)};
  }
  const tableInstance: any = useTable(
    {
      columns,
      data,
      initialState
    },    
    useColumnOrder
    );

    const {
      getTableProps,
      getTableBodyProps,
      headerGroups,
      rows,
      prepareRow,
      allColumns,
      setColumnOrder,
      toggleHideAllColumns,
    } = tableInstance;
    useEffect(() => {
      let savedColumns
    // savedColumns = localStorage.getItem('columns');
    if(tableType === 'User' && panel !== "Contacts Drilldown"){
      savedColumns = localStorage.getItem('contactsTableHeaderOrder');
    }
    else if(tableType === 'User' && panel === "Contacts Drilldown"){
      savedColumns = localStorage.getItem('contactsDrilldownTableHeaderOrder');
    }
    else if(tableType === 'Task'){
      savedColumns = localStorage.getItem('taskColumnOrder');
    }
    else if(tableType === 'CallLogs'){
      savedColumns = localStorage.getItem('calllogColumnOrder');
    }
      if(savedColumns){

        setColumnOrder(JSON.parse(savedColumns));
      }
  }, [tableType]);


  useEffect(() => {
    if (organizationUsers) {
      let activeUsers = organizationUsers.filter(
        (item) => item.status === 'ACTIVE'
      );
      setActiveUsers(activeUsers.length);
    }
  }, [organizationUsers]);

  const setColumns = (columnList: any) => {
    setColumnOrder(columnList);

    if(tableType === 'User' && panel !== "Contacts Drilldown"){
      localStorage.setItem('contactsTableHeaderOrder', JSON.stringify(columnList));
    }
    else if(tableType === 'User' && panel === "Contacts Drilldown"){
      localStorage.setItem('contactsDrilldownTableHeaderOrder', JSON.stringify(columnList));
    }
    else if(tableType === 'Task'){
      localStorage.setItem('taskColumnOrder', JSON.stringify(columnList));
    }
    else if(tableType === 'CallLogs'){
      localStorage.setItem('calllogColumnOrder', JSON.stringify(columnList));
    }
    // else if(tableType === 'Project'){
    //   localStorage.setItem('projectColumnOrder', JSON.stringify(columnList));
    // }
  };

  const checkStatus = (email: string) => {
    const l = data.filter((item) => item.reporting_to === email);
    if (l.length > 0) {
      return false;
    } else {
      return true;
    }
  };

  const onToggle = (event: any, row: any) => {
    if (tableType === 'Organization') {
      setLoad(true);
      if (event.target.checked) {
        let check = checkStatus(row.original.user_email);
        if (check === true) {
          updateUserStatusMongo(row.original.uid, 'INACTIVE', (data) =>
            setLoad(data),row.original.organization_id
          );
        } else {
          dispatcher(
            showSnackbarAction(
              'Some Users Are Reporting To This User!!',
              'warning'
            )
          );
          setLoad(false);
        }
      } else {
        let activeUsers = organizationUsers.filter(
          (item) => item.status === 'ACTIVE'
        );

        if (activeUsers.length === Number(organization.no_of_employees)) {
          dispatcher(
            showSnackbarAction(
              'Maximum active users limit reached!!',
              'warning'
            )
          );
          setLoad(false);
        } else {
          updateUserStatusMongo(row.original.uid, 'ACTIVE', (data) => setLoad(data),row.original.organization_id);
        }
      }
    }
    if (tableType === 'Super admin') {
      setLoad(true);
      if (event.target.checked) {
        updateOrganizationStatus(
          row.original.organization_id,
          'INACTIVE',
          (data) => setLoad(data)
        );
      } else {
        updateOrganizationStatus(
          row.original.organization_id,
          'ACTIVE',
          (data) => setLoad(data)
        );
      }
    }
    if (tableType === 'API') {
      setLoad(true);
      if (event.target.checked) {
        updateAPIStatus(row.original.api_key, 'INACTIVE', (data) =>
          setLoad(data)
        );
      } else {
        updateAPIStatus(row.original.api_key, 'ACTIVE', (data) =>
          setLoad(data)
        );
      }
    }
  };

  const changeImport = (event: any, row: any) => {
    setLoad(true);
    if (event.target.checked) {
      updateUserImport(
        row.original.organization_id,
        row.original.user_email,
        true,
        dispatcher,
        (data) => setLoad(data)
      );
    } else {
      updateUserImport(
        row.original.organization_id,
        row.original.user_email,
        false,
        dispatcher,
        (data) => setLoad(data)
      );
    }
  };

  const onCheck = (event: any, row: any) => {

    if (
      tableType === 'User' ||
      tableType === 'Project' ||
      tableType === 'Organization' ||
      tableType === 'Task' ||
      tableType === 'projects' ||
      tableType === 'API Leads' ||
      tableType === "CallLogs" ||
      tableType ==="DeletedLogs"
    ) {
      if (event.target.checked) {
        let data = [...selectedRows];
        if(tableType === "API Leads"){
          data.push(row._id);
        }else{
          data.push(row.contactId || row.project_id);
        }
        setSelectedRows(data);
        if (selectedRowsData) {
          let rowData = [...selectedRowsData];
          rowData.push(row);
          setSelectedRowsData && setSelectedRowsData(rowData);
        }
      } else if (!event.target.checked) {
        let data = [...selectedRows];
        let item;
        if(tableType === "API Leads"){
          item = selectedRows.indexOf(row._id);
        }else{
          item = selectedRows.indexOf(row.contactId || row.project_id);
        }
        if (item > -1) {
          data.splice(item, 1);
        }
        setSelectedRows(data);
        if (selectedRowsData) {
          let rowData = [...selectedRowsData];
          let val = selectedRowsData.indexOf(row);
          if (val > -1) {
            rowData.splice(val, 1);
          }
          setSelectedRowsData && setSelectedRowsData(rowData);
        }
      }
    }

    if (event.target.checked) {
      let data = [...selectedRows];
      if(tableType === "API Leads"){
        data.push(row._id);
      }else{
        data.push(row.contactId || row.project_id);
      }
      setSelectedRows(data);
    } else if (!event.target.checked) {
      let data = [...selectedRows];
      let item;
      if(tableType === "API Leads"){
        item = selectedRows.indexOf(row._id);
      }else{
        item = selectedRows.indexOf(row.contactId || row.project_id);
      }
      if (item > -1) {
        data.splice(item, 1);
      }
      setSelectedRows(data);
    }
  };

  const clearFilter = () => {
    if (tableType === 'Reenquired') {
      dispatcher(setReenquiredSearchString(''));
      // window.location.reload()
    }
    if (tableType === 'User') {
      dispatcher(setContactsSearchString(''));
    }
    if (tableType === 'Project') {
      dispatcher(setContactsSearchString(''));
    }
    if (tableType === 'Task') {
      dispatcher(setTasksSearchString(''));
    }
    if (tableType === 'CallLogs') {
      dispatcher(setCallsSearchString(''));
    }
   
    var key: any;
    const preserveLocalStorageFields = localstorageKey;
    for (var i = 0; i < localStorage.length; i++) {
      key = localStorage.key(i);
      
        if (!preserveLocalStorageFields.includes(key) && key !== 'columns' && key !== 'isLightMode' && key !== 'totalMonths' && key !== 'lastAlertTime') {
        localStorage.removeItem(key);
      }
    }

    dispatcher(setClearFilter(true));
    // if (tableType === 'User') {
    //   history.push('/');
    // }
    if (tableType === 'Project') {
      history.push('/projects');
    }
  };
  const location: any = useLocation();

  const handleIconClick = (id: number): void => {
    setShowUnlockBoosterTooltip((prev: number) => (prev === id ? null : id)); // Toggle the tooltip
  };

  const handleMouseEnterOnMaskBooster= (id: number,data: any): void => {
    if(data.lead_sub_type && data.lead_sub_type === "Masked Booster Leads"){
      setShowUnlockBoosterTooltip((prev: number) => (prev ? prev : id)); // Toggle the tooltip
    }
    else{
      setShowUnlockBoosterTooltip(null);
    }
  };

  // const handleClickOutside = (event: MouseEvent): void => {
  //   if (tableRef.current && !tableRef.current.contains(event.target as Node)) {
  //     setShowUnlockBoosterTooltip(null); // Hide tooltip if clicked outside
  //   }
  // };

  // useEffect(() => {
  //   document.addEventListener("click", handleClickOutside);
  //   return () => document.removeEventListener("click", handleClickOutside);
  // }, []);

  const tdStyles = {
    backgroundColor:theme?themeColors.tdBackgroundColor:themeColors.tdBackgroundColorDark,
    color:theme?themeColors.textPrimary:themeColors.textPrimaryDark,
  }

  const footerStyles = {
    backgroundColor:theme?themeColors.thBackgroundColor:themeColors.thBackgroundColorDark,
    color:theme?themeColors.textPrimary:themeColors.textPrimaryDark,
  }

  const buttonStyles = {
    backgroundColor:theme?themeColors.buttonPrimary:themeColors.buttonPrimaryDark,
    color:theme?themeColors.textPrimary:themeColors.textPrimaryDark,
  }
  const trBorderStyles = {
    borderBottom:theme?`1px solid ${themeColors.trBorderColor}`:`1px solid ${themeColors.trBorderColorDark}`,
  }  


  return (
    <>
      <div className={commonStyle.child} id="scrollable">
        {load === true && <Loading />}
        <div style={{ width: 'max-content' }} {...getTableProps()}>
         {/* {firstLoad &&  */}
             <TableHeader
             headerGroups={headerGroups}
             selectAll={(data) => {
               selectAll(data);
               setChecked(data);
             }}
             panel={tableType}
             allCheck={checked}
             DrillDownpanel={DrillDownpanel}
           />
         {/* } */}
          <InfiniteScroll
            style={{ overflow: 'visible',minHeight: "100vh",width:"100%",marginBottom:"-10rem", paddingRight:'100px' ,...tdStyles }}
            dataLength={currentLimit}
            next={() => setCurrentLimit(currentLimit + 20)}
            hasMore={rows.length > currentLimit}
            loader={''}
            scrollableTarget="scrollable"
            className={commonStyle.infiniteScroll}
          >
            <div {...getTableBodyProps()}>
              {rows.slice(0, currentLimit).map((row: any, index: number) => {
                prepareRow(row);
                return (
                  
                  // <div
                  //   {...row.getRowProps()}
                  //     style={
                  //       row.original.status === 'INACTIVE'
                  //         ? {
                  //           // backgroundColor: '#D3D3D3',
                  //           // borderWidth: 2,
                  //           display: 'flex',
                  //           flexDirection: 'row',
                  //           ...trBorderStyles
                  //         }:row.original.lead_source==="Self Generated"?
                  //         {
                  //           // backgroundColor: '#ffffff',
                  //           display: 'flex',
                  //           flexDirection: 'row',
                  //           borderBottom:`1px solid #299FF3`,
                  //         }
                  //         : {
                  //           // backgroundColor: '#ffffff',
                  //           display: 'flex',
                  //           flexDirection: 'row',
                            
                  //           ...trBorderStyles
                  //         }
                  //     }
                  // >
                    <div
                          onMouseEnter={()=>{
                            handleMouseEnterOnMaskBooster(index,row.values)
                          }}
                          {...row.getRowProps()}
                          style={
                            row.original.status === 'INACTIVE'
                              ? {
                                  // backgroundColor: '#D3D3D3',
                                  // borderWidth: 2,
                                  display: 'flex',
                                  flexDirection: 'row',
                                  ...trBorderStyles
                                }
                              : (row.values.lead_source === 'Self Generated' || row.values.source === 'Self Generated')
                              ? {
                                  // backgroundColor: '#ffffff',
                                  display: 'flex',
                                  flexDirection: 'row',
                                  // borderBottom: '2px solid green', // add blue border at the bottom
                                  position: 'relative', // add relative position to show the tag
                                  // borderRadius:3,
                                  // borderBottom: '2px solid green', // add blue border at the bottom
                                  // borderLeft: '3px solid #40AEFD',
                                  ...trBorderStyles
                                  // position: 'elative',
                                }
                              : {
                                  // backgroundColor: '#ffffff',
                                  display: 'flex',
                                  flexDirection: 'row',
                                  ...trBorderStyles,
                                }
                          }
                        >
                    <div className={commonStyle.sticky} style={tdStyles} >
                      {row.values.lead_sub_type !== 'Masked Booster Leads' ? 
                        <>
                          <input
                            style={{ marginRight: (tableType === 'Task' || tableType === 'API Leads' || tableType === "CallLogs") ? '30px': (tableType === "DeletedLogs") ? "30px" : "8px", accentColor: "4gb(39, 159, 159)" }}
                            type="checkbox"
                            onChange={(e) => {
                              onCheck(e, row.original);
                            }}
                            checked={tableType === "API Leads" ? selectedRows.includes(row.original._id) : selectedRows.includes(row.original.contactId || row.original.project_id)}
                            disabled={tableType === 'LeadDistributor' || tableType === 'API'}
                          />
                          {tableType !== 'Task' && tableType !== 'API Leads' && tableType !== "CallLogs" && tableType!=="DeletedLogs" &&(
                            <FiEdit3
                              size={15}
                              color="#279EA0"
                              style={{ marginRight: '7px' }}
                              onClick={() => {
                                if (tableType === 'Organization') {
                                  history.push({
                                    pathname: '/addUsers',
                                    state: {
                                      detail: row.original,
                                      edit: true,
                                    },
                                  });
                                } else if (tableType === 'User') {
                                  googleAnalyticsCTAClick("Contact Edit Lead Button", "Contact Screen", user)
                                  if (row.original.transfer_status === true) {
                                    dispatcher(
                                      showSnackbarAction(
                                        'Lead With Transfer Status TRUE Cannot be Edited!!',
                                        'error'
                                      )
                                    );
                                  } else {
                                    let data = { ...row.original };
                                    history.push({
                                      pathname: '/editContacts',
                                      state: {
                                        detail: data,
                                      },
                                    });
                                  }
                                } else if (tableType === 'projects') {
                                  googleAnalyticsCTAClick("Listing Edit Lead Button", "Listing Screen", user)
                                  let data = { ...row.original };
                                  history.push({
                                    pathname: '/editProjects',
                                    state: {
                                      detail: data,
                                    },
                                  });
                                } else if (tableType === 'Super admin') {
                                  history.push({
                                    pathname: '/editOrganizations',
                                    state: { detail: row.original },
                                  });
                                } else if (tableType === 'LeadDistributor') {
                                  setShowDistributionModal(true);
                                  setDistributionData(row.original);
                                  setIndex(index);
                                } else if (tableType === 'API') {
                                  setApiEdit && setApiEdit(true);
                                  setApiModal && setApiModal(true);
                                  setApiData && setApiData(row.original);
                                }
                              }}
                            />
                          )}
                        </>
                        :
                        <div style={{width:"3rem"}}></div>
                      }
                      
                      <div style={{width:"1rem"}}>{pageSize * page + index + 1}</div>
                    </div>
                    {/* add the tag if lead_source is "Self Generated" */}
                    {(row.values.lead_source === 'Self Generated' ||row.values.source === 'Self Generated') && (
                                <BookmarksIcon
                                  style={{
                                    fontSize: "1.1rem",
                                    position: 'absolute',
                                    // position:"sticky",
                                    top: 10,
                                    left: 100,
                                    // backgroundColor: 'blue',
                                    alignSelf:"center",
                                    color: '#40AEFD',
                                    // padding: '2px 5px',
                                    borderRadius: '5px',
                                    fontWeight: 'bold',
                                  }}
                                />
                            
                          )}
                    {row.cells.map((cell: any) => {
                      return (
                        <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                          <div
                            className={commonStyle.td}

                            {...cell.getCellProps()}
                            style={
                              cell.column.Header === 'News Link'
                                ? { minWidth: '490px', ...tdStyles } 
                                :  cell.column.Header === 'Contact Number' ?
                                { minWidth: '130px', maxWidth:'130px', ...tdStyles } 
                                : tdStyles
                            }

                            onClick={() => {
                              if ((cell.column.Header === 'Customer Name' && tableType === 'User')) {
                                googleAnalyticsCTAClick("Contact Lead Detail Button", "Contact Screen", user)
                              }
                              else if ((cell.column.Header === 'Customer Name' && tableType === 'Task')) {
                                googleAnalyticsCTAClick("Task Lead Detail Button", "Task Screen", user)
                              }
                              else if ((cell.column.Header === 'Customer Name' && tableType === 'CallLogs')) {
                                googleAnalyticsCTAClick("CallLogs Lead Detail Button", "CallLogs Screen", user)
                              }
                              if (
                                (cell.column.Header === 'Customer Name' &&
                                  tableType === 'User') ||
                                (cell.column.Header === 'Customer Name' &&
                                  tableType === 'Task') ||
                                (cell.column.Header === 'Customer Name' &&
                                  tableType === 'Reenquired') ||
                                (cell.column.Header === 'Customer Name' &&
                                  tableType === 'CallLogs')
                              ) {
                                if (cell.row.original.transfer_status === true) {
                                  dispatcher(
                                    showSnackbarAction(
                                      'This is a Transfered Lead!!',
                                      'error'
                                    )
                                  );
                                } else {
                                  history.push({
                                    pathname: '/contactDetails',
                                    state: {
                                      detail: {
                                        ...cell.row.original,
                                        created_at:
                                          cell.row.original[
                                            'created_at'
                                          ] ?
                                            cell.row.original[
                                              'created_at'
                                            ]
                                              .toDate() :
                                            "",
                                        lead_assign_time: cell.row.original[
                                          'lead_assign_time'
                                        ]
                                          ? cell.row.original[
                                            'lead_assign_time'
                                          ].toDate()
                                          : '',
                                        next_follow_up_date_time: cell.row
                                          .original['next_follow_up_date_time']
                                          ? cell.row.original[
                                            'next_follow_up_date_time'
                                          ].toDate()
                                          : '',
                                        modified_at: cell.row.original[
                                          'modified_at'
                                        ]
                                          ? cell.row.original[
                                            'modified_at'
                                          ].toDate()
                                          : '',
                                        stage_change_at: cell.row.original[
                                          'stage_change_at'
                                        ]
                                          ? cell.row.original[
                                            'stage_change_at'
                                          ].toDate()
                                          : '',
                                        feedback_time: cell.row.original[
                                          'feedback_time'
                                        ]
                                          ? cell.row.original[
                                            'feedback_time'
                                          ].toDate()
                                          : '',
                                        due_date: cell.row.original['due_date']
                                          ? cell.row.original['due_date'].toDate
                                            ? cell.row.original[
                                              'due_date'
                                            ].toDate()
                                            : ''
                                          : '',
                                      },
                                    },
                                  });
                                }
                              } else if (
                                (cell.column.Header === 'Project Name' &&
                                  tableType === 'projects')
                              ) {
                                history.push({
                                  pathname: "/projectDetails",
                                  state: {
                                    "AllProjectdata": tableRows,
                                    detail: {
                                      ...cell.row.original,
                                      created_at: cell.row.original[
                                        "created_at"
                                      ]
                                        ? cell.row.original[
                                          "created_at"
                                        ]
                                          ? cell.row.original[
                                          "created_at"
                                          ]
                                          : ""
                                        : "",
                                    },
                                  },
                                })
                              }
                            }}
                          >
                            {(cell.column.Header === "Buyer Intent") ?
                              <div style={{ display: "flex", gap: "0.25rem", alignItems: "center", cursor: "pointer" }}>
                                <VisibilityOffIcon sx={{ fontSize: "1rem", color: themeColors.primary }} />
                                <a style={{ textDecoration: "underline", color: themeColors.primary }} href="https://property.magicbricks.com/microsite/lp/download-readpro/?utm_source=web_app_download_banner_link&utm_medium=read_pro" target="_blank" onClick={() => {
                                  pushToGA(
                                    "event_tracking",
                                    "read pro",
                                    "read pro",
                                    "link app banner click",
                                    user
                                  )
                                }}>View in App</a>
                              </div>
                              : (cell.column.Header === "Budget") ? cell?.row?.original?.display_budget?cell?.row?.original?.display_budget:cell?.row?.original?.budget
                              : cell.render('Cell')
                            }
                          </div>
                          <div style={{position:"relative"}}>
                            {
                              cell.column.Header === "Contact Number" && (
                                (cell.column.Header === 'Contact Number' &&
                                  tableType === 'User' && cell.row.original.lead_sub_type === "Masked Booster Leads") ? <img onClick={() => {
                                    // setShowUnlockBoosterTooltip(index)
                                    handleIconClick(index)
                                  }} className={commonStyle.boosterMaskLock} src={BoosterLockRedUnlock} />
                                  : <div style={{ width: "20px" }}></div>

                              )
                            }
                            {(showUnlockBoosterTooltip == index && cell.column.Header === 'Contact Number' &&
                              tableType === 'User') && 
                              <UnlockBoosterLeadsTooltip setShowUnlockBoosterTooltip={setShowUnlockBoosterTooltip} leadData = {cell.row.original}/>
                            }
                          </div>
                        </div>
                      );
                    })}
                    {(callRecordingModule.is_call_recording_subscribed && callRecordingModule.is_call_recording_enabled && tableType === 'CallLogs') && (
                      <div
                        className={commonStyle.td}
                        style={tdStyles}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingRight: '0.5rem',
                            cursor: "pointer"
                            // justifyContent: 'space-between',
                          }}
                          onClick={() => {
                            row.original.call_recording_url &&
                              setShowAudioPlayer(true)
                            setCallRecordingUrl(row.original.call_recording_url)
                          }}
                        >
                          {row.original.call_recording_url ? <PlayCircleOutlineIcon /> : "N/A"}
                        </div>
                      </div>
                    )}
                    {tableType === 'Organization' && (
                      <div
                        className={commonStyle.td}
                        style={tdStyles}
                      >
                        <div
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            paddingRight: '10px',
                            justifyContent: 'space-between',
                          }}
                        >
                          {(tableType === 'Organization' ||
                            tableType === 'Super admin' ||
                            tableType === 'API') && (
                              <CustomToggle
                                size="small"
                                onChange={(e) => onToggle(e, row)}
                                checked={
                                  row.original.status === 'INACTIVE'
                                    ? true
                                    : false
                                }
                              />
                            )}
                        </div>
                      </div>
                    )}
                    {tableType === 'Organization' ? (
                      <div className={commonStyle.tdSmall} style={tdStyles}>
                        {row.original.profile === 'Lead Manager' ? (
                          <input
                            style={{ marginRight: "10px",accentColor:"rgb(39, 159, 159)"}}
                            type="checkbox"
                            onChange={(e) => changeImport(e, row)}
                            checked={
                              row.original.import === true ? true : false
                            }
                          />
                        ) : null}
                      </div>
                    ) : null}

                    {tableType === 'Organization' ? (
                      <div
                        className={commonStyle.tdSmall}
                        style={{ paddingLeft: '30px',...tdStyles }}
                      >
                        {row.original.profile === 'Lead Manager' ? (
                          <button
                            className={commonStyle.branchButton}
                            onClick={() => {
                              setBranch && setBranch(true);
                              setUid && setUid(row.original.uid);
                            }}
                          >
                            Branch
                          </button>
                        ) : null}
                      </div>
                    ) : null}
                  </div>
                );
              })}
              {showDistributionModal && (
                <DistributionModel
                  open={showDistributionModal}
                  organization_id={user.organization_id}
                  close={() => {
                    setShowDistributionModal(false);
                  }}
                  data={distributionData}
                  index={indexs}
                />
              )}
              {
                showAudioPlayer && (
                  <AudioPlayer
                    open={showAudioPlayer}
                    close={() => {setShowAudioPlayer(false) }}
                    url={callRecordingUrl}
                  />
                )
              }
            </div>
          </InfiniteScroll>
        </div>
      </div>
      <div style={{display: 'flex',flexDirection: 'column',width: '100%',alignItems:"center", borderRadius:" 0.5rem",padding: "0.5rem",marginTop:"1rem",marginBottom:"-1rem",...footerStyles}}>
      <div>
        <span>
          Page <strong>{page + 1 + '  '}</strong>
        </span>
        <select
          className={commonStyle.dropDownSelecct}
          value={pageSize}
          onChange={(e) => {
            setPageSize(Number(e.target.value));
          }}
        >
          {pageSizeOptions.map((pagesize) => (
            <option key={pagesize} value={pagesize}>
              Show {pagesize}
            </option>
          ))}
        </select>
        <button
          className={commonStyle.addBox}
          onClick={(event:any) => {
            event.preventDefault();
            setChecked(false);
            if (page !== 0) {
                setPage(page - 1);
            }
          }}
          style={page === 0 ? { backgroundColor: "#ced4da" } : {}}
          disabled={page === 0 ? true : false}
        >
          Previous
        </button>
        <button
          className={commonStyle.addBox}
          onClick={(event:any) => {
            event.preventDefault(); 
            setChecked(false);
              setPage(page + 1);
          }}
          style={page === lastPage ? { backgroundColor: "#212529" } : {}}
          disabled={page === lastPage ? true : false}
        >
          Next
        </button>
      </div>
      <div className={commonStyle.footer_table}>
        <div style={{marginLeft:"20px"}} >
          <button
            className={commonStyle.clearFilter}
            style={buttonStyles}
            // style={
            //   location.state?.detail || localStorage.length > 0
            //     ? { color: '#fff', borderColor: '#fff' }
            //     : { color: '#555', borderColor: '#555' }
            // }
            onClick={() => clearFilter()}
          >
            Clear Filter
          </button>
          {tableType === 'Organization' && (
            <>
              <div className={commonStyle.selectContainer}>
                <p className={commonStyle.countHead}>Total Licence:</p>
                <p className={commonStyle.number}>
                  {organization.no_of_employees}
                </p>
              </div>
              <div className={commonStyle.selectContainer}>
                <p className={commonStyle.countHead}>Active Licence:</p>
                <p className={commonStyle.number}>{active}</p>
              </div>
            </>
          )}
        </div>
        <div>
          <p className={commonStyle.countHead}>Selected Records: {selectedRows.length}</p>
        </div>
        <div>
          <p style={{marginRight:"20px"}} className={commonStyle.countHead}>Total Records:{totalCount ? totalCount : 0}</p>
        </div>
      </div>
      </div>
      {showColumnModal === true && (
        <ColumnManagerModal
          columnsList={allColumns}
          open={showColumnModal}
          close={hideColumnModal}
          onChangeColumns={(data: any[]) => setColumns(data)}
          toggleAllColumns={toggleHideAllColumns}
          tableType = {tableType}
        />
      )}
    </>
  );
};

const mapStateToProps = (state: any) => {
  return {
    user: state.user.data,
    organizationUsers: state.organizationUsers.data,
    role: state.user.role,
    organization: state.organization,
    theme: state.theme.isLightMode,
    organizationData: state.organization.organizationData,
    callRecordingModule: state.callRecordingModule
  };
};

export default connect(mapStateToProps)(ApiCustomTable);
